import React from "react";
import Icon from "../../../components/AppIcon";

const SkillsPreview = () => {
  const skills = [
    {
      name: "FileMaker",
      icon: "Database",
      level: 95,
      category: "データベース",
    },
    {
      name: "Photoshop",
      icon: "BookImage",
      level: 90,
      category: "デザイン",
    },
    {
      name: "Illustrator",
      icon: "PenTool",
      level: 88,
      category: "デザイン",
    },
    {
      name: "PHP",
      icon: "FileText",
      level: 85,
      category: "プログラミング",
    },
    { name: "MySQL", icon: "Sheet", level: 82, category: "プログラミング" },
    {
      name: "HTML",
      icon: "FileCode2",
      level: 80,
      category: "プログラミング",
    },
  ];

  const categories = [...new Set(skills.map((skill) => skill.category))];

  return (
    <section className="py-20 bg-muted/30">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            専門知識・技術
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            最新の技術やフレームワークに精通し、常に学び続け、業界のトレンドに適応していきます。
          </p>
        </div>

        {/* Skills Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6 mb-12">
          {skills?.map((skill, index) => (
            <div
              key={skill?.name}
              className="group bg-card rounded-xl p-6 shadow-elevation-sm hover:shadow-elevation-md transition-layout hover-lift cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex flex-col items-center space-y-3">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-micro">
                  <Icon name={skill?.icon} size={24} className="text-primary" />
                </div>

                <div className="text-center">
                  <h3 className="font-semibold text-foreground text-sm">
                    {skill?.name}
                  </h3>
                  <p className="text-xs text-text-secondary mt-1">
                    {skill?.category}
                  </p>
                </div>

                {/* Skill Level Bar */}
                <div className="w-full bg-muted rounded-full h-2">
                  <div
                    className="bg-gradient-to-r from-primary to-accent h-2 rounded-full transition-all duration-1000 ease-out"
                    style={{ width: `${skill?.level}%` }}
                  ></div>
                </div>

                <span className="text-xs font-medium text-primary">
                  {skill?.level}%
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Category Filter Pills */}
        <div className="flex flex-wrap justify-center gap-3">
          {categories?.map((category) => (
            <div
              key={category}
              className="px-4 py-2 bg-card border border-border rounded-full text-sm font-medium text-text-secondary hover:text-primary hover:border-primary transition-micro cursor-pointer"
            >
              {category}
            </div>
          ))}
        </div>

        {/* Skills Summary */}
        <div className="mt-16 bg-card rounded-2xl p-8 shadow-elevation-sm">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Code" size={32} className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2">
                FileMakerのシステム開発
              </h3>
              <p className="text-text-secondary">
                Claris FileMaker
                Proを活用したフロントエンドシステム開発を行います。
              </p>
            </div>

            <div>
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Server" size={32} className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2">
                ウェブシステム開発
              </h3>
              <p className="text-text-secondary">
                PHP、MySQLを使ったウェブシステムの開発を行います。
              </p>
            </div>

            <div>
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Palette" size={32} className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2">
                UI/UX Design
              </h3>
              <p className="text-text-secondary">
                直感的なユーザーインターフェースとシームレスなユーザー体験の設計
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsPreview;
